import { EmptyList } from 'components/core/empty-list'
import { C1Icon } from 'components/core/icons/C1Icon'
import { C1Link } from 'components/core/links/C1Link'
import List from 'components/core/list'
import { C1TableReduxColumn } from 'components/core/list/C1Table/C1TableRedux'
import { C1TableReduxHook } from 'components/core/list/C1Table/C1TableReduxHook'
import { RelativeTimestamp } from 'components/core/time/display'
import { AppEntitlementWithUserBindingValueWithId } from 'lib/actions/apps/app-entitlement'
import { C1AppId, ManualCatalogResourceTypeId } from 'lib/constants/system'
import { routes } from 'lib/routes'
import { Minus } from 'lucide-react'
import { AppEntitlementSearchServiceSearchGrantsRequest, AppEntitlementWithExpired } from 'pbts/c1/api/app/v1/app_entitlement'
import { ReactElement, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { searchGrantsApi } from 'redux_toolkit/entitlements'

type UserEnrollmentsProps = {
    userId: string;
}

const cols: C1TableReduxColumn<AppEntitlementWithUserBindingValueWithId>[] = [
    {
        field: 'entitlement',
        flex: 2,
        label: <FormattedMessage defaultMessage="Access profile" id="components_user_enrollments_catalog" />,
        Component: ({ row: grant }) => (
            <C1Link href={routes.accessProfiles.detail(grant.entitlement?.id ?? '')}>
                {grant.entitlement?.appResource?.displayName}
            </C1Link>
        ),
    },
    {
        field: 'joined',
        flex: 2,
        label: <FormattedMessage defaultMessage="Date added" id="components_user_enrollments_joined_at" />,
        Component: ({ row: grant }) => (grant.appEntitlementUserBinding?.appEntitlementUserBindingCreatedAt
            ? <RelativeTimestamp date={grant.appEntitlementUserBinding?.appEntitlementUserBindingCreatedAt} variant="date" />
            : <C1Icon icon={Minus} size="sm" sx={{ color: 'action.disabled' }} />),
    },
]

export const UserEnrollments = ({ userId }: UserEnrollmentsProps) : ReactElement => {
    const table = useMemo(() => {
        return <C1TableReduxHook<
                AppEntitlementSearchServiceSearchGrantsRequest,
                AppEntitlementWithUserBindingValueWithId
            >
            cols={cols}
            request={AppEntitlementSearchServiceSearchGrantsRequest.create({
                expandMask: { paths: ['*'] },
                appIds: [C1AppId],
                appUserIds: [userId],
                resourceTypeIds: [ManualCatalogResourceTypeId],
            })}
            hook={searchGrantsApi.useSearchGrants}
            invalidateHook={searchGrantsApi.useInvalidateSearchGrants}
            emptyState={<EmptyList
                text={<FormattedMessage id="components_past_grants" defaultMessage="No profiles" />}
            />}
        />
    }, [userId])

    return <List<AppEntitlementWithExpired> table={table} />
}
